module.exports = __webpack_public_path__ + "static/media/dna-welcome-animation.9c55743a.svg";